import { ClipboardList, X, ExternalLink } from "lucide-react";
import { Section } from "../dc";
import { SERVICES, C, leadsFor } from "./data";

export const ServicesRequested = ({ onPick }) => {
  const total = SERVICES.reduce((a, [, n]) => a + n, 0);
  return (
    <Section title="Services requested" sub="What leads ask for most, and how often each one books. Click a service to see its leads." icon={ClipboardList} testid="lx-services">
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {SERVICES.map(([s, n, w]) => (
          <button key={s} onClick={() => onPick(`Service: ${s}`, n)} style={{ background: "none", border: 0, padding: 0, textAlign: "left", cursor: "pointer" }} data-testid={`lx-service-${s.split(" ")[0].toLowerCase()}`}>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, gap: 8 }}>
              <span style={{ fontWeight: 600 }}>{s}</span>
              <span className="mono"><b>{n}</b> <span className="muted">· {Math.round((n / total) * 100)}% of requests · {n ? Math.round((w / n) * 100) : 0}% won</span></span>
            </div>
            <div style={{ height: 6, background: "#E6EEEF", borderRadius: 3, marginTop: 4 }}><div style={{ width: `${(n / SERVICES[0][1]) * 100}%`, height: 6, background: C.teal, borderRadius: 3 }} /></div>
          </button>
        ))}
      </div>
    </Section>
  );
};

export const LeadDrill = ({ pick, onClose }) => {
  if (!pick) return null;
  const rows = leadsFor(pick.stage, pick.n);
  return (
    <Section title={`Leads · ${pick.stage}`} sub={`${pick.n} leads${pick.n > rows.length ? ` · showing first ${rows.length}` : ""}. Click a name to open the lead in a new tab.`} icon={ClipboardList} testid="lx-drill"
      right={<button className="btn btn-sm" onClick={onClose} data-testid="lx-drill-close"><X size={14} />Close</button>}>
      <div style={{ overflowX: "auto" }}>
        <table className="table" style={{ width: "100%" }}>
          <thead><tr>{["Lead", "Source", "Service", "Rep", "Age"].map((h) => <th key={h} style={{ textAlign: "left" }}>{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.id} style={{ background: i % 2 ? "#F5F9F9" : undefined }} data-testid={`lx-drill-row-${i}`}>
                <td style={{ fontWeight: 700, whiteSpace: "nowrap" }}>
                  <a href={`/leads/${r.id}`} target="_blank" rel="noreferrer" style={{ color: C.teal, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 4 }} data-testid={`lx-drill-link-${i}`}>
                    {r.name}<ExternalLink size={12} />
                  </a>
                </td>
                <td className="muted" style={{ fontSize: 12 }}>{r.source}</td>
                <td style={{ fontSize: 12 }}>{r.service}</td>
                <td style={{ fontSize: 12 }}>{r.rep}</td>
                <td className="mono">{r.age}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Section>
  );
};
